import { useState, useEffect } from 'react';
import request from '../../helpers/requests';
import { saveData, saveImage, getImage } from '../../helpers/indexedDbHelper';

export const useRecommendedMenu = () => {
  const [recommendedDish, setRecommended] = useState();
 
  const getRecommendedMenu = async () => {
    try {
      const restaurant_id = 4;
      const res = await request.get(`/recommended/menu/${restaurant_id}`);
      const { data } = res.data;
      console.log({data})


      const downloadImage = async (url, id, changeimage) => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          await saveImage(id, {blob, changeimage});
        } catch (error) {
          console.error(`Error al descargar la imagen ${id}:`, error);
        }
      };
      

    const validImages = async (id) => {
      console.log("validando imagen")
      const dataimage = await getImage(id);
      console.log("imagen validada")
      return dataimage;
    };
      
      const downloadPromises = [];
      
      data.forEach((item) => {
      const images = [
        {
          url: item.imagehorizontal,
          changeimage: item.changeimagehorizontal,
          id: `menu-image-h-${item.id}`,
        }
      ];

      images.forEach(({ url, id, changeimage }) => {
        if (url) {
          const fullUrl = `https://tumenu.online/images/menus/${url}`;
          downloadPromises.push(
            (async () => {
              const validImage = await validImages(id);
             
                if (!validImage || !validImage.data || validImage.data.changeimage != changeimage) {
                  console.log('Downloading image', fullUrl, id);
                  await downloadImage(fullUrl, id, changeimage);
                }
             
              
            })()
          );
        }
      });
      });
      

      setRecommended(data);
    } catch (error) {
      alert(error)
      // Manejar el error según sea necesario
    }
  };

  useEffect(() => {
    getRecommendedMenu();
  }, []);

  return recommendedDish;
};
